import axios, { AxiosPromise } from 'axios';

import { IInventory } from '../../../@types/model/masterData/inventory/inventory';

export default class InventoryHttpService {
    public static getInventoryData() : AxiosPromise<Array<IInventory>> {
        return axios.get(`${API_URL}/v1/Inventory/GetAllWeb`);
    }

    public static addOrUpdateInventory(data : IInventory) : AxiosPromise<IInventory> {
        return axios.post(`${API_URL}/v1/Inventory/PostInventory`, data);
    }

    public static deleteInventory(inventoryId : number) : AxiosPromise<IInventory> {
        return axios.delete(`${API_URL}/v1/Inventory/Delete`, {
            params : { inventoryId },
        });
    }
}
